function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button as BaseButton } from "sprout-ui-dom/dist/Button";
import { createElement } from "react";
import styled from "styled-components";
import { themeGet, media } from "sprout-ui-theme";
import { Text, Flex } from "sprout-ui-primitives";
import { Link } from "react-router-dom";
const Button = styled(BaseButton)`
  flex-direction: column;
  align-items: flex-start;

  position: relative;
  padding: 24px;

  ${media.target("pointer")} {
    :hover {
      background: ${themeGet("colors.grey.200")};
    }
  }

  :active {
    background: ${themeGet("colors.grey.300")};
  }

  transition: background 0.15s linear;
`;
const PageActionItem = (props)=>{
    const { icon , label , to , href , description  } = props;
    return /*#__PURE__*/ _jsxs(Button, _objectSpread({
        as: to ? Link : href ? "a" : undefined
    }, href ? {
        href
    } : null, to ? {
        to
    } : null, {
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                alignItems: "center",
                children: [
                    icon && /*#__PURE__*/ _jsx(Flex, {
                        as: "span",
                        mr: 3,
                        children: /*#__PURE__*/ createElement(icon)
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        fontSize: 3,
                        fontWeight: "medium",
                        children: label
                    })
                ]
            }),
            description && /*#__PURE__*/ _jsx(Text, {
                fontSize: 2,
                lineHeight: 1.5,
                mt: 1,
                ml: icon ? 9 : undefined,
                children: description
            })
        ]
    }));
};
export default PageActionItem;
